/**
 * Client-side analytics events for Yandex.Metrika and VK Pixel.
 * These fire only when tracking is enabled and the respective pixel is loaded.
 */

declare global {
  interface Window {
    ym?: (counterId: number, method: string, ...args: unknown[]) => void;
    _tmr?: Array<Record<string, unknown>>;
  }
}

/** Send a Yandex.Metrika reachGoal event */
export function ymGoal(goal: string, params?: Record<string, unknown>) {
  try {
    const id = (window as any).__YM_ID__;
    if (id && window.ym) {
      window.ym(id, "reachGoal", goal, params);
    }
  } catch (e) {
    console.warn("[analytics] ym error", e);
  }
}

/** Send a VK Pixel event */
export function vkGoal(goal: string, params?: Record<string, unknown>) {
  try {
    if (window._tmr) {
      window._tmr.push({ type: "reachGoal", id: (window as any).__VK_PIXEL_ID__, goal, ...params });
    }
  } catch (e) {
    console.warn("[analytics] vk error", e);
  }
}

/** Send event to all active pixels */
export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  ymGoal(eventName, params);
  vkGoal(eventName, params);
}
